"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  DesignToolMagicWand1: ['design-tool-magic-wand-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.543,10.547l-2.671-2.67a.39.39,0,0,1-.051-.185l1.394-4.185a1.314,1.314,0,0,0-1.722-1.723l-4.17,1.392a.412.412,0,0,1-.189-.037L13.453.457a1.211,1.211,0,0,0-2.132,1.026l.457,4.093a.428.428,0,0,1-.044.11L7.442,8.071a1.234,1.234,0,0,0,.334,2.363l2.83.652a.249.249,0,0,1,.121.42L.366,21.866a1.25,1.25,0,0,0,1.768,1.768l10.36-10.36a.25.25,0,0,1,.42.121l.653,2.831a1.234,1.234,0,0,0,2.363.334L18.3,12.287a.382.382,0,0,1,.1-.063l4.118.456A1.212,1.212,0,0,0,23.543,10.547Z']],
  DesignToolCompass: ['design-tool-compass', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.000 8.000 L5.000 8.000 L5.000 11.500 L0.000 11.500 Z', 'M.25,17.5a.25.25,0,0,0-.25.25v1.74a.5.5,0,0,0,.053.225l1.776,3.553a.719.719,0,0,0,1.342,0l1.776-3.553A.5.5,0,0,0,5,19.49V17.75a.25.25,0,0,0-.25-.25Z', 'M4.75,6.5A.25.25,0,0,0,5,6.25V5.521a2.5,2.5,0,0,0-5,0V6.25a.25.25,0,0,0,.25.25Z', 'M23.547,23.837a1,1,0,0,0,.29-1.385l-1.282-1.958a.251.251,0,0,1-.018-.242,1.468,1.468,0,0,0-.083-1.427L15.173,7.235A.5.5,0,0,0,14.75,7h-6a.5.5,0,0,0-.469.326L6.407,12.389A1.052,1.052,0,0,1,5.529,13H.25a.25.25,0,0,0-.25.25v2.5A.25.25,0,0,0,.25,16h7.5a2.057,2.057,0,0,0,1.819-1.261L11.68,9.112a.25.25,0,0,1,.447-.044l7.179,11.681a1.514,1.514,0,0,0,1.347.716.252.252,0,0,1,.221.113l1.289,1.97A1,1,0,0,0,23.547,23.837Z', 'M8.75,5.5h6a.5.5,0,0,0,.5-.5V3.5a3.5,3.5,0,0,0-7,0V5A.5.5,0,0,0,8.75,5.5Zm3-4a1,1,0,1,1-1,1A1,1,0,0,1,11.75,1.5Z']],
  DesignToolMagicWand: ['design-tool-magic-wand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.543,10.547l-2.671-2.67a.39.39,0,0,1-.051-.185l1.394-4.185a1.314,1.314,0,0,0-1.722-1.723l-4.17,1.392a.412.412,0,0,1-.189-.037L13.453.457a1.211,1.211,0,0,0-2.132,1.026l.457,4.093a.428.428,0,0,1-.044.11L7.442,8.071a1.234,1.234,0,0,0,.334,2.363l2.83.652a.249.249,0,0,1,.121.42L.366,21.866a1.25,1.25,0,0,0,1.768,1.768l10.36-10.36a.25.25,0,0,1,.42.121l.653,2.831a1.234,1.234,0,0,0,2.363.334L18.3,12.287a.382.382,0,0,1,.1-.063l4.118.456A1.212,1.212,0,0,0,23.543,10.547Zm-4.923-.311A2.159,2.159,0,0,0,16.566,11.3l-1.156,2.08a.25.25,0,0,1-.462-.065l-.5-2.147a2.263,2.263,0,0,0-1.618-1.618l-2.146-.494a.251.251,0,0,1-.065-.463l2.081-1.156a2.166,2.166,0,0,0,1.061-2.055l-.144-1.294a.251.251,0,0,1,.426-.205l.672.673a2.275,2.275,0,0,0,2.222.523l2.5-.832a.25.25,0,0,1,.316.316l-.833,2.5a2.281,2.281,0,0,0,.525,2.221l.674.673a.251.251,0,0,1-.2.426Z']],
  DesignToolGlue1: ['design-tool-glue-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.838,20.216A5.888,5.888,0,0,0,1.75,22.5a1.5,1.5,0,0,0,3,0,5.888,5.888,0,0,0-1.088-2.284A.519.519,0,0,0,2.838,20.216Z', 'M6.111,13.145a.252.252,0,0,0-.212-.07.249.249,0,0,0-.183.126L3.524,17.145a1.163,1.163,0,0,0,1.581,1.581L9.05,16.534a.25.25,0,0,0,.055-.395Z', 'M15.7.815a2.783,2.783,0,0,0-4.233.351L6.848,7.634a.5.5,0,0,0-.094.291V11.46a.5.5,0,0,0,.147.353l3.536,3.537a.5.5,0,0,0,.353.146h3.535a.5.5,0,0,0,.291-.094l6.468-4.62a2.783,2.783,0,0,0,.351-4.233Z']],
  DesignToolPaperGlue: ['design-tool-paper-glue', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.455,5.533a1,1,0,0,0-1.414,0l-7.249,7.25a1.5,1.5,0,0,0,0,2.12L9.084,19.2a1.5,1.5,0,0,0,2.122,0l7.249-7.249a1,1,0,0,0,0-1.414ZM8.8,13.788l4-4A1,1,0,1,1,14.211,11.2l-4,4A1,1,0,1,1,8.8,13.788Z', 'M4.207,15.782a1.029,1.029,0,0,0-1.414,0L1.171,17.4a3.714,3.714,0,0,0,0,5.414,3.82,3.82,0,0,0,2.707,1.176,3.82,3.82,0,0,0,2.707-1.176L8.206,21.2a1,1,0,0,0,0-1.414Z', 'M23.416,4.158,19.83.572A2.051,2.051,0,0,0,17,.573L14.917,2.658a2,2,0,0,0,0,2.828L18.5,9.071a2,2,0,0,0,2.828,0l2.086-2.085A2,2,0,0,0,23.416,4.158ZM18.239,2.164a.25.25,0,0,1,.354,0l.735.735a.249.249,0,0,1,0,.353L17.6,4.984a.249.249,0,0,1-.353,0l-.736-.735a.252.252,0,0,1,0-.354Zm1.854,5.317a.252.252,0,0,1-.354,0l-.729-.73a.249.249,0,0,1,0-.353l1.732-1.732a.252.252,0,0,1,.354,0l.729.73a.25.25,0,0,1,0,.353Z']],
  DesignToolInk: ['design-tool-ink', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.5,7h13a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2H5.5a2,2,0,0,0-2,2V5A2,2,0,0,0,5.5,7Zm5.25-2a.25.25,0,0,1-.25-.25V2.25A.25.25,0,0,1,10.75,2h2.5a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25Zm7.75-.25a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25V2.25A.25.25,0,0,1,15.75,2h2.5a.25.25,0,0,1,.25.25Zm-13-2.5A.25.25,0,0,1,5.75,2h2.5a.25.25,0,0,1,.25.25v2.5A.25.25,0,0,1,8.25,5H5.75a.25.25,0,0,1-.25-.25Z', 'M18.774,10.3a.507.507,0,0,1-.274-.447V9a.5.5,0,0,0-.5-.5H6a.5.5,0,0,0-.5.5v.857a.5.5,0,0,1-.274.447C4.105,10.872,1.5,12.517,1.5,15.5v5A3.5,3.5,0,0,0,5,24H19a3.5,3.5,0,0,0,3.5-3.5v-5C22.5,12.517,19.9,10.872,18.774,10.3ZM17.5,15.5a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H6.5a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1Z']],
  DesignToolMagnet: ['design-tool-magnet', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.411,14.027a2,2,0,0,0,0-2.828L22,9.784a2,2,0,0,0-2.827,0h0l-2.887,2.887-3.594,3.594a3.5,3.5,0,0,1-4.951-4.949L11.33,7.722h0l2.888-2.888a2,2,0,0,0,0-2.828L12.8.591a2,2,0,0,0-2.827,0h0L7.089,3.479l-4.3,4.3A9.5,9.5,0,0,0,16.222,21.215l4.3-4.3h0ZM12.628,3.243a.251.251,0,0,1,0,.354L10.8,5.423a.25.25,0,0,1-.354,0L9.386,4.363a.252.252,0,0,1,0-.354l1.827-1.826a.25.25,0,0,1,.353,0Zm7.365,11.373a.252.252,0,0,1-.354,0l-1.06-1.061a.249.249,0,0,1,0-.353l1.826-1.827a.251.251,0,0,1,.354,0l1.061,1.061a.251.251,0,0,1,0,.354Z']],
  DesignToolQuill: ['design-tool-quill', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.366.019C23.2.064,21.508.54,19.214,1.435a.252.252,0,0,0-.147.154l-1.33,3.99a.248.248,0,0,1-.2.169.252.252,0,0,1-.241-.109L15.676,3.216a.249.249,0,0,0-.319-.085A27.212,27.212,0,0,0,8.3,7.925a15.606,15.606,0,0,0-4.39,6.856,5.342,5.342,0,0,0,.183,3.484.249.249,0,0,1-.05.281L.293,22.293a1,1,0,0,0,1.414,1.414L13.3,12.115a.5.5,0,0,1,.707.707L6.985,19.847a.25.25,0,0,0,.154.426,6.368,6.368,0,0,0,2.08-.18,15.606,15.606,0,0,0,6.856-4.39c5.112-5.111,7.8-14.666,7.907-15.069A.5.5,0,0,0,23.366.019Z']],
  DesignToolQuill2: ['design-tool-quill-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.8,1.26a.75.75,0,0,0-.64-1.254A23.886,23.886,0,0,0,4.628,13.662L1.993,19.488a.643.643,0,0,0-.045.132L.154,22.467a1,1,0,1,0,1.692,1.066l4.518-7.208a.5.5,0,0,1,.846.533L6.02,18.747a.25.25,0,0,0,.306.364L9.764,17.7a12.368,12.368,0,0,0,5.844-4.835.25.25,0,0,0-.021-.3L13.31,9.913A.251.251,0,0,1,13.5,9.5H17a.219.219,0,0,0,.2-.135A10.824,10.824,0,0,1,19.249,6.17Z']],
  DesignToolPencilRuler: ['design-tool-pencil-ruler', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.750 7.000 L7.250 7.000 L7.250 19.250 L5.750 19.250 Z', 'M8.250 7.000 L9.750 7.000 L9.750 19.250 L8.250 19.250 Z', 'M3.250 7.000 L4.750 7.000 L4.750 19.250 L3.250 19.250 Z', 'M9.3,6a.25.25,0,0,0,.226-.358L6.951.283a.522.522,0,0,0-.9,0L3.478,5.642A.25.25,0,0,0,3.7,6Z', 'M3.5,20.25a.25.25,0,0,0-.25.25v.25a3.25,3.25,0,0,0,6.5,0V20.5a.25.25,0,0,0-.25-.25Z', 'M19.25,0h-5a1.5,1.5,0,0,0-1.5,1.5V2.75A.25.25,0,0,0,13,3h1.75a.5.5,0,0,1,0,1H13a.25.25,0,0,0-.25.25v2.5A.25.25,0,0,0,13,7h1.75a.5.5,0,0,1,0,1H13a.25.25,0,0,0-.25.25v2.5A.25.25,0,0,0,13,11h1.75a.5.5,0,0,1,0,1H13a.25.25,0,0,0-.25.25v2.5A.25.25,0,0,0,13,15h1.75a.5.5,0,0,1,0,1H13a.25.25,0,0,0-.25.25V22.5a1.5,1.5,0,0,0,1.5,1.5h5a1.5,1.5,0,0,0,1.5-1.5V1.5A1.5,1.5,0,0,0,19.25,0Zm-2.5,19.5a1.25,1.25,0,1,1-1.25,1.25A1.252,1.252,0,0,1,16.75,19.5Z']],
  DesignToolPens: ['design-tool-pens', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.375,8.772a3.973,3.973,0,0,1-1.895-.478.252.252,0,0,0-.23,0,.248.248,0,0,0-.136.185,19.387,19.387,0,0,0-.239,3.025,57.262,57.262,0,0,0,1.4,11.619,1.132,1.132,0,0,0,2.207,0,57.358,57.358,0,0,0,1.4-11.619,19.387,19.387,0,0,0-.239-3.025A.248.248,0,0,0,22.5,8.29a.252.252,0,0,0-.23,0A3.973,3.973,0,0,1,20.375,8.772Z', 'M20.71.1a.75.75,0,0,0-1.076.786c.114.731-.171,1.032-.773,1.591a3,3,0,0,0-1.236,2.293,2.75,2.75,0,0,0,5.5,0C23.125,3.094,22.279.886,20.71.1Z', 'M11.375,6a.5.5,0,0,0-.5.5v13a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V6.5a.5.5,0,0,0-.5-.5Z', 'M5.875,0a2,2,0,0,0-2,2V3.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V2A2,2,0,0,0,5.875,0Z', 'M7.375,5h-3a3.5,3.5,0,0,0-3.5,3.5v6.25a.75.75,0,0,0,1.5,0V8.5A2,2,0,0,1,3.518,6.693a.25.25,0,0,1,.357.226V18a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V5.5A.5.5,0,0,0,7.375,5Z', 'M13.343.324a.521.521,0,0,0-.936,0l-1.5,4A.5.5,0,0,0,11.375,5h3a.5.5,0,0,0,.468-.676Z', 'M14.375,21h-3a.5.5,0,0,0-.5.5V22a2,2,0,0,0,4,0v-.5A.5.5,0,0,0,14.375,21Z', 'M7.375,19.5h-3a.5.5,0,0,0-.459.7l1.5,3.5a.5.5,0,0,0,.918,0l1.5-3.5A.5.5,0,0,0,7.375,19.5Z']],
  DesignToolQuill1: ['design-tool-quill-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.3,12.115a.5.5,0,0,1,.707.707L7.258,19.573A.25.25,0,0,0,7.435,20h3.236a2.484,2.484,0,0,0,1.768-.732l6.835-6.835A16.578,16.578,0,0,0,23.98,2.81,2.481,2.481,0,0,0,23.267.732,2.509,2.509,0,0,0,21.19.019a16.539,16.539,0,0,0-5.968,1.956.254.254,0,0,0-.11.123l-2.881,7a.25.25,0,0,1-.468-.017l-1.01-3.027a.248.248,0,0,0-.179-.165.252.252,0,0,0-.235.067L4.732,11.56A2.487,2.487,0,0,0,4,13.328v5.154a.249.249,0,0,1-.073.177L.293,22.293a1,1,0,0,0,1.414,1.414Z']],
  DesignToolSelectionWand: ['design-tool-selection-wand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.616,10.616.366,21.866a1.25,1.25,0,0,0,1.768,1.768l11.25-11.25a1.25,1.25,0,0,0-1.768-1.768Z', 'M23,7H20a1,1,0,0,0,0,2h3a1,1,0,0,0,0-2Z', 'M19.707,5.707l2-2a1,1,0,1,0-1.414-1.414l-2,2a1,1,0,0,0,1.414,1.414Z', 'M16,0a1,1,0,0,0-1,1V4a1,1,0,0,0,2,0V1A1,1,0,0,0,16,0Z', 'M11.707,2.293a1,1,0,0,0-1.414,1.414l2,2a1,1,0,0,0,1.414-1.414Z', 'M9,9h3a1,1,0,0,0,0-2H9A1,1,0,0,0,9,9Z', 'M16,11a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0V12A1,1,0,0,0,16,11Z', 'M19.707,10.293a1,1,0,0,0-1.414,1.414l2,2a1,1,0,0,0,1.414-1.414Z']],
  DesignToolStamp: ['design-tool-stamp', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,21H1.5a.5.5,0,0,0-.5.5v1A1.5,1.5,0,0,0,2.5,24h19A1.5,1.5,0,0,0,23,22.5v-1A.5.5,0,0,0,22.5,21Z', 'M21.5,14c-3.72,0-5.955-.579-6.644-1.723-.7-1.16.243-2.939,1.073-4.508A7.035,7.035,0,0,0,17,4.967,4.827,4.827,0,0,0,12,0,4.814,4.814,0,0,0,7,4.967,7.064,7.064,0,0,0,8.083,7.8c.829,1.562,1.768,3.334,1.074,4.485S6.231,14,2.5,14C.944,14,0,16.778,0,18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18C24,16.778,23.056,14,21.5,14Z']],
  DesignToolStamp1: ['design-tool-stamp-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,21H2a.5.5,0,0,0-.5.5A2.5,2.5,0,0,0,4,24H20a2.5,2.5,0,0,0,2.5-2.5A.5.5,0,0,0,22,21Z', 'M19.5,13.5h-3c-.858,0-2-.26-2-2.5a4.606,4.606,0,0,1,1.16-2.719A5.442,5.442,0,0,0,17,5,5,5,0,0,0,7,5,5.442,5.442,0,0,0,8.34,8.281,4.606,4.606,0,0,1,9.5,11c0,2.24-1.142,2.5-2,2.5h-3A4.505,4.505,0,0,0,0,18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18,4.505,4.505,0,0,0,19.5,13.5Z']],
  DesignToolGlue: ['design-tool-glue', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.448,18a.253.253,0,0,0-.184-.073.25.25,0,0,0-.179.083L.192,21.247A.75.75,0,0,0,.751,22.5H4a.752.752,0,0,0,.507-.2L6,20.929a.244.244,0,0,0,.081-.178.25.25,0,0,0-.073-.183Z', 'M7.27,20.035a1.256,1.256,0,0,0,1.7.068c.611-.524,1.8-1.278,2.894-.447a1.269,1.269,0,0,0,1.7-.171l.182-.227a.25.25,0,0,0-.018-.333L5.055,10.258a.249.249,0,0,0-.341-.011l-.273.238a1.257,1.257,0,0,0-.111,1.641c.832,1.094.078,2.282-.444,2.894a1.254,1.254,0,0,0,.065,1.7Z', 'M14.312,18.1a.249.249,0,0,0,.372-.021L23.1,7.6a1.884,1.884,0,0,0-.133-2.486L18.379.523A1.841,1.841,0,0,0,15.9.443L5.844,9.256a.25.25,0,0,0-.012.365Z', 'M24,23a1,1,0,0,0-1-1H9a1,1,0,0,0,0,2H23A1,1,0,0,0,24,23Z']],
  DesignToolQuill3: ['design-tool-quill-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.267.732A2.511,2.511,0,0,0,21.19.019a16.594,16.594,0,0,0-7.18,2.7.252.252,0,0,0-.106.257l1.315,6.572a.249.249,0,0,0,.422.127l2.5-2.524a.5.5,0,0,1,.71.7l-2.2,2.222a.25.25,0,0,0,.177.426H20.8A.248.248,0,0,0,21,10.4,16.571,16.571,0,0,0,23.98,2.81,2.481,2.481,0,0,0,23.267.732Z', 'M9.375,15.989a.25.25,0,0,0,.068-.225L8.049,8.794a.251.251,0,0,0-.422-.128L4.732,11.56A2.487,2.487,0,0,0,4,13.328v5.154a.251.251,0,0,1-.073.177L.293,22.293a1,1,0,0,0,1.414,1.414Z', 'M10.225,14.579a.251.251,0,0,0,.423.127l3.72-3.75a.25.25,0,0,0,.068-.225L13.064,3.873a.247.247,0,0,0-.161-.187.253.253,0,0,0-.244.043q-.567.472-1.092,1L8.9,7.392a.249.249,0,0,0-.068.225Z', 'M10.381,16.5a.248.248,0,0,0-.178.074l-2.976,3A.25.25,0,0,0,7.405,20h3.266a2.481,2.481,0,0,0,1.768-.733l2.341-2.34A.25.25,0,0,0,14.6,16.5Z', 'M15.34,11.5a.247.247,0,0,0-.177.074l-3.472,3.5a.25.25,0,0,0,.178.426H16.1a.249.249,0,0,0,.178-.075l3.438-3.5a.25.25,0,0,0-.178-.425Z']],
  DesignToolPenStation: ['design-tool-pen-station', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.459,16.5a4,4,0,0,0-4-4h-.5V12a1,1,0,0,0-1-1h-12a1,1,0,0,0-1,1v9.5a2.5,2.5,0,0,0,2.5,2.5h9a2.5,2.5,0,0,0,2.5-2.5v-1h.5A4,4,0,0,0,21.459,16.5Zm-4,2h-.25a.249.249,0,0,1-.25-.25v-3.5a.249.249,0,0,1,.25-.25h.25a2,2,0,1,1,0,4Z', 'M5.649,2.864a.249.249,0,0,0,.017-.429L3.3.905a.5.5,0,0,0-.75.511l.422,2.53a.25.25,0,0,0,.366.178Z', 'M3.646,5.094a.25.25,0,0,0-.1.334l2.22,4.3a.5.5,0,0,0,.445.27h3a.5.5,0,0,0,.438-.741l-3.026-5.5a.252.252,0,0,0-.339-.1Z', 'M13.539,7.293l-.007,0a3.525,3.525,0,0,1-.636-.348.252.252,0,0,0-.361.084L11.293,9.257A.5.5,0,0,0,11.73,10h1.832a.5.5,0,0,0,.468-.323L14.7,7.893a.251.251,0,0,0-.2-.337,3.526,3.526,0,0,1-.68-.156C13.727,7.368,13.633,7.333,13.539,7.293Z', 'M17.017,2.815a3.679,3.679,0,0,0-2.81-2.8.5.5,0,0,0-.536.761c.529.805.21,1.282-.353,1.994a3.621,3.621,0,0,0-.542.819,2.037,2.037,0,0,0,1.151,2.783,2.044,2.044,0,0,0,2.245-.257A3.363,3.363,0,0,0,17.017,2.815Z']],
  DesignToolSharpener: ['design-tool-sharpener', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,6.92V1.5A1.5,1.5,0,0,0,19.5,0H4.5A1.5,1.5,0,0,0,3,1.5V6.92a.5.5,0,0,0,.134.341A6.93,6.93,0,0,1,5,12a6.93,6.93,0,0,1-1.866,4.739A.5.5,0,0,0,3,17.08V22.5A1.5,1.5,0,0,0,4.5,24h15A1.5,1.5,0,0,0,21,22.5V17.08a.5.5,0,0,0-.134-.341,6.951,6.951,0,0,1,0-9.478A.5.5,0,0,0,21,6.92ZM7,13.5V3A1,1,0,0,1,8,2H9.25a.25.25,0,0,1,.25.25v15.1a.25.25,0,0,1-.395.2A4.964,4.964,0,0,1,7,13.5ZM11,2.25A.25.25,0,0,1,11.25,2H16a1,1,0,0,1,1,1V13.5a5,5,0,0,1-5.79,4.937.248.248,0,0,1-.21-.246Z', 'M12.500 8.000 A1.500 1.500 0 1 0 15.500 8.000 A1.500 1.500 0 1 0 12.500 8.000 Z']],
  DesignToolRazorCut: ['design-tool-razor-cut', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.838,2.739c-.726-.727-2.728-1.515-3.889-.353L9.693,11.659a.25.25,0,0,0,0,.353L13.4,15.731a.249.249,0,0,0,.35,0l9.436-9.1.006-.006C24.182,5.639,23.812,3.711,22.838,2.739Z', 'M8.987,12.72a.247.247,0,0,0-.177-.073.251.251,0,0,0-.177.073L7.158,14.2a.25.25,0,0,0,0,.353l3.658,3.671a.25.25,0,0,0,.35,0l1.5-1.45a.254.254,0,0,0,.076-.178.251.251,0,0,0-.073-.179Z', 'M8.466,17.989a.249.249,0,0,0-.179-.073.245.245,0,0,0-.177.075l-1.3,1.333a.75.75,0,1,1-1.075-1.047l1.317-1.355a.25.25,0,0,0,0-.35L6.1,15.614a.249.249,0,0,0-.354,0l-5.3,5.312a.75.75,0,0,0,.63,1.273l6.118-.816A2.484,2.484,0,0,0,8.6,20.705l1.131-1.091a.254.254,0,0,0,.076-.178.247.247,0,0,0-.073-.179Z']]
};
exports["default"] = _default;